import {css, unsafeCSS} from "lit";
import {sbkCoreBreakpointXl} from "@/tokens/variables";

const breakpointXl = unsafeCSS(`${sbkCoreBreakpointXl}`);

export const chNavStyles = css` 
    :host {
    }
    
    .container {
        display: none;

        @media all and (min-width: ${breakpointXl}) {
            display: block;
            position: sticky;
            overflow-y: auto;
            max-height: 100vh;
            top: var(--sbkCoreSpacing3xl);
            margin-bottom: var(--sbkCoreSpacing3xl);

            -webkit-overflow-scrolling: touch;
            -ms-overflow-style: -ms-autohiding-scrollbar;

            &::-webkit-scrollbar {
                display: none;
            }
        }
    }
`;